import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PrimaryButton } from "../components/Buttons";
import { PasswordInput } from "../components/Inputs";
import { useLoaderStore } from "../context";
import { useAlert, useApi } from "../hooks";
import { isValidPassword } from "../utils/helpers";
import { useNavigate } from "react-router";
import storage from "../utils/storage";
import constants from "../utils/constants";

export default function ResetPassword() {
  const alert = useAlert();
  const navigate = useNavigate();
  const { post } = useApi();

  const { token, redirectToMarkt } = useParams();
  const { setShowLoader } = useLoaderStore();

  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");

  const handleSubmit = async () => {
    if (!isValid()) return;

    setShowLoader(true);

    await post("public/resetPassword", { token, password: newPassword })
      .then((res) => {
        storage.setItem(storage.ITEMS.username, res.username);
        alert("Success!", "Password successfully reset", "success");
        if (!!redirectToMarkt) {
          window.location.href = constants.MARKT_ADDRESS;
          return
        }
        navigate("/");
      })
      .catch((err) => {
        alert("Unsuccessful reset password attempt", "Could not reset password", "error");
        console.error(err);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const isValid = () => {
    if (
      !newPassword ||
      !newPassword.trim() ||
      !newPasswordConfirmation ||
      !newPasswordConfirmation.trim()
    ) {
      alert(
        "Invalid input",
        "Please enter a valid password and confirmation password",
        "warning"
      );
      return false;
    }

    if (!isValidPassword(newPassword.trim())) {
      alert("Invalid input", "Password is not complex enough", "warning");
      return false;
    }

    if (newPassword.trim() !== newPasswordConfirmation.trim()) {
      alert("Invalid input", "Passwords do not match", "warning");
      return false;
    }

    return true;
  };

  return (
    <>
      <h1 className="text-3xl font-bold text-primaryColor">Reset Password</h1>
      <h5 className="mt-1 mb-6">
        Or{" "}
        <Link to="/" className="text-primaryColor hover:text-primaryColor/50">
          back to sign in
        </Link>
      </h5>

      <div className="w-full space-y-6">
        <div>
          <PasswordInput
            label="New Password"
            name="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            showInfo
          />
        </div>
        <div>
          <PasswordInput
            label="Retype New Password"
            name="retypeNewPassword"
            value={newPasswordConfirmation}
            onChange={(e) => setNewPasswordConfirmation(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSubmit();
            }}
          />
        </div>
        <PrimaryButton text="Change Password" onClick={handleSubmit} />
      </div>
    </>
  );
}
